import { CardHeader, Icon, Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
	List,
	ListItem,
	ListItemLink,
	ListItemSubtitle,
	ListItemTrailing,
} from "../../../shared/ui/list/listComponents";
import { ListItemTitle } from "../../../shared/ui/list/ListItemTitle";
import { DateTimeDurationDistance } from "../common/DurationDistance";
import { DurationSubtitle } from "../common/DurationSubtitle";
import { LoadingOverlay } from "../common/LoadingOverlay";
import { StyledCard, StyledCardBody } from "../common/StyledCard";
import { StyledList } from "../common/StyledList";
import { ViewAllListItemTitle } from "../common/ViewAllListItemTitle";
import { eventsWidgetService } from "./service";

export const EventsWidget = () => {
	const { t } = useTranslation();
	const { data, isLoading } = useQuery({
		queryKey: eventsWidgetService.key,
		queryFn: () => eventsWidgetService.get().then((x) => x.data.data),
	});

	return (
		<StyledCard>
			<CardHeader>{t("Current & Upcoming Events")}</CardHeader>
			<StyledCardBody>
				<List>
					{data && !data.total && (
						<ListItem>
							<ViewAllListItemTitle>{t("No data available.")}</ViewAllListItemTitle>
						</ListItem>
					)}
					{data?.events.map((x) => (
						<ListItem key={x.id}>
							<ListItemLink to={`/events/active/${x.id}`}>
								<ListItemTitle>
									{x.name}
									<DurationSubtitle duration={x} />
								</ListItemTitle>
								<ListItemTrailing>
									<DateTimeDurationDistance duration={x} />
								</ListItemTrailing>
							</ListItemLink>
						</ListItem>
					))}
				</List>
				<StyledList>
					<ListItem>
						<ListItemLink to="/events/active">
							<ViewAllListItemTitle>
								<Icon $icon="external_link" style={{ width: 16, height: 16 }} />
								{t("View all")}
								{data && data.total - data.events.length > 0 && (
									<ListItemSubtitle>
										({t("{{moreCount}} more", { moreCount: data.total - data.events.length })})
									</ListItemSubtitle>
								)}
							</ViewAllListItemTitle>
						</ListItemLink>
					</ListItem>
				</StyledList>
			</StyledCardBody>
			{isLoading && (
				<LoadingOverlay>
					<Loading />
				</LoadingOverlay>
			)}
		</StyledCard>
	);
};
